export const PROFILES_FETCH = 'PROFILES_FETCH';
export const PROFILES_FETCH_ALL = 'PROFILES_FETCH_ALL';
export const PROFILES_IS_FETCING = 'PROFILES_IS_FETCHING';
export const PROFILES_API = 'profiles';
export const PROFILE_EDIT = 'PROFILE_EDIT';
export const PROFILE_SAVE = 'PROFILE_SAVE';
export const PROFILE_FILTER = 'PROFILE_FILTER';
export const SINGLE_PROFILE_FETCH = 'SINGLE_PROFILE_FETCH'
export const PROFILES_TYPES = {
    PERLOT: 'Per Lot',
    PERMILLION: 'Per Million',
}


// WEBPACK FOOTER //
// ./src/constants/profiles.js